<template>
  <div class="con">
    <div v-if="infoList.length == 1" v-html="content"></div>
    <div v-else>
      <ul class="info-list">
        <li v-for="item in infoList" :key="item.id" @click="fnToInfoDetails(item.id)">
          <h3>{{ item.title }}</h3>
          <span>{{ $dayjs(item.create_time).format("YYYY-MM-DD") }}</span>
        </li>
      </ul>
    </div>
    <div v-if="type=='apply'" class="apply">
      <h3>選擇入會身份</h3>
      <button @click="fnToApply(1)">個人</button>
      <button @click="fnToApply(2)">企業</button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      infoList: [],
      content: "",
      type: "",
    };
  },
  computed: {
    ...mapState(["validToken", "isPc"]),
  },
  methods: {
    async getAssociationInfo() {
      const { data: res } = await this.$http.get(
        `/api/v2/association/about/SZTX/${this.type}`
      );
      // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.infoList = res.data?res.data:[];
      if (res.data&&res.data.length == 1) {
        this.content = res.data[0].content;
        this.$zhTran()
      }
    },
    fnToInfoDetails(id){
      // console.log(id)
      this.$router.push({
        path: `/infoDetails/${id}`,
      })
    },
    fnToApply(th){
      if (!this.validToken) {
        if(this.isPc){
          this.$store.state.isDialogVisible = true;
          return false
        }else{
          this.$router.push({
            path: `/login`,
          })
          return false
        }
        
      }

      if(th==1){
        this.$router.push({
          path: `/apply-person`,
        })
      }else{
        this.$router.push({
          path: `/apply-company`,
        })
      }
      
    }
  },
  watch: {
    $route(val) {
      // console.log(val);
      this.type = val.name;
      this.getAssociationInfo();
    },
  },
  mounted() {
    // console.log(this.$route);
    this.type = this.$route.name;
    this.getAssociationInfo();
  },
};
</script>

<style lang="less" scoped>

.con {
  margin: 0 35px;
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 26px;
  font-weight: normal!important;
  p{
    font-size: 18px;
    line-height: 26px;
    font-weight: normal!important;
  }
  span{
    font-size: 18px;
    line-height: 26px;
    font-weight: normal!important;
  }
}
.info-list {
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    width: 100%;
    cursor: pointer;
    color: #333;
    font-size: 18px;
    
  }
  h3{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  h3:hover {
    color: #4f4e95;
    text-decoration: underline;
  }
  h3::before {
    content: "";
    width: 6px;
    height: 6px;
    background: #dddddd;
    display: inline-block;
    margin-right: 15px;
    vertical-align: middle;
  }
  span {
    font-size: 14px;
    color: #666;
    min-width: 90px;
  }
}
.apply{
  h3{
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  button{
    display: block;
    margin-bottom: 20px;
    border: none;
    background: #4f4e95;
    color: #fff;
    font-size: 16px;
    padding: 10px 80px;
    border-radius: 40px;
    cursor: pointer;
  }
}
@media screen and (max-width: 768px) {
  .con {
    margin: 10px 0;
    padding: 0 20px;
  }
}
</style>
